import React from "react";

const Pending = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2219_4944)">
      <rect
        x="4"
        y="4"
        width="16"
        height="16"
        rx="2"
        fill="#FFF4CC"
        fill-opacity="0.5"
        shape-rendering="crispEdges"
      />
    </g>
    <path
      d="M15.375 7.875H14.25V7.5C14.2494 7.30127 14.1702 7.11085 14.0297 6.97033C13.8892 6.8298 13.6987 6.75059 13.5 6.75H10.5C10.3013 6.75059 10.1108 6.8298 9.97033 6.97033C9.8298 7.11085 9.75059 7.30127 9.75 7.5V7.875H8.625C8.42627 7.87559 8.23585 7.9548 8.09533 8.09533C7.9548 8.23585 7.87559 8.42627 7.875 8.625V16.5C7.87559 16.6987 7.9548 16.8892 8.09533 17.0297C8.23585 17.1702 8.42627 17.2494 8.625 17.25H12V16.5H8.625V8.625H9.75V9.75H14.25V8.625H15.375V10.5H16.125V8.625C16.1244 8.42627 16.0452 8.23585 15.9047 8.09533C15.7642 7.9548 15.5737 7.87559 15.375 7.875ZM13.5 9H10.5V7.5H13.5V9Z"
      fill="#936A00"
    />
    <path
      d="M14.8125 11.625C13.467 11.625 12.375 12.717 12.375 14.0625C12.375 15.408 13.467 16.5 14.8125 16.5C16.158 16.5 17.25 15.408 17.25 14.0625C17.25 12.717 16.158 11.625 14.8125 11.625ZM15.6169 15.2081L14.5688 14.16V12.6H15.0563V13.9601L15.9581 14.862L15.6169 15.2081V15.2081Z"
      fill="#936A00"
    />
    <defs>
      <filter
        id="filter0_d_2219_4944"
        x="0"
        y="0"
        width="24"
        height="24"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2219_4944"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2219_4944"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default Pending;
